
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.477 5.651l.965 15.455c.046.893.696 1.546 1.546 1.546h8.886c.854 0 1.491-.653 1.546-1.546l.966-15.455","stroke":"currentColor","stroke-width":".824","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.93 5.651h17-17z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M3.93 5.651h17","stroke":"currentColor","stroke-width":".824","stroke-miterlimit":"10","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M9.34 5.652V3.72a1.156 1.156 0 011.159-1.16h3.864a1.156 1.156 0 011.159 1.16v1.932M12.43 8.742v10.819M8.953 8.742l.386 10.819M15.908 8.742l-.386 10.819","stroke":"currentColor","stroke-width":".824","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    